import { render, staticRenderFns } from "./TicketChange.vue?vue&type=template&id=1ae03f99&scoped=true&"
import script from "./TicketChange.vue?vue&type=script&lang=js&"
export * from "./TicketChange.vue?vue&type=script&lang=js&"
import style0 from "./TicketChange.vue?vue&type=style&index=0&id=1ae03f99&lang=less&scoped=true&"
import style1 from "./TicketChange.vue?vue&type=style&index=1&id=1ae03f99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae03f99",
  null
  
)

export default component.exports